<template>
  <div class="dynamic-tables">
    <div v-if="showLoading" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>
    </div>
    <div v-if="!showLoading">
      <h2 class="page-title">Habis Masa Berlaku</h2>
      <Widget customHeader>
        <div>
          <div class="d-flex justify-content-between">
            <div></div>
            <div class="d-flex">
              <div class="d-flex">
                <div class="d-flex align-items-center mr-2">
                  <label for="search" class="mr-2 mb-0">Search: </label>
                  <input v-model="search.value" type="text" class="form-control" id="search" />
                </div>
                <div>
                  <select v-model="search.field" class="form-control">
                    <option value="nama_pemohon">Nama Pemohon</option>
                    <option value="jenis_permohonan">Jenis Permohonan</option>
                    <option value="nomor_izin_terbit">Nomor Penerbitan</option>
                    <option value="tanggal_penerbitan">Tgl. Penerbitan</option>
                    <option value="pic_name">PIC</option>
                    <option value="masa_berlaku">Masa Berlaku</option>
                    <option value="createdAt">Tgl. Dibuat</option>
                  </select>
                </div>
              </div>
              <div class="d-flex ml-4">
                <div class="d-flex align-items-center mr-2">
                  <label for="search" class="mb-0">Sort By: </label>
                </div>
                <div>
                  <select v-model="sort.field" class="form-control">
                    <option value="tanggal_penerbitan">Tgl. Penerbitan</option>
                    <option value="masa_berlaku">Masa Berlaku</option>
                    <option value="createdAt">Tgl. Dibuat</option>
                  </select>
                </div>
                <div class="ml-2">
                  <select v-model="sort.direction" class="form-control">
                    <option value="DESC">DESC</option>
                    <option value="ASC">ASC</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <table id="tableHabisMasaBerlaku" class="table" style="width: 100%">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Pemohon</th>
                <th>Jenis Permohonan</th>
                <th>Nomor Penerbitan</th>
                <th>Tgl. Penerbitan</th>
                <th>Masa Berlaku</th>
                <th>PIC</th>
                <th>Tgl. Dibuat</th>
                <th>Status</th>
                <th>File</th>
                <!-- <th>Aksi</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in dataPermohonan" :key="index">
                <!-- No -->
                <td>{{ index + pagination.firstInPage }}</td>
                <!-- <td>{{ index }}</td> -->
                <!-- Nama Pemohon -->
                <td>
                  <div style="width: 300px; text-wrap: wrap">
                    {{ data.nama_pemohon }}
                  </div>
                </td>
                <!-- Jenis Permohonan -->
                <td>{{ data.jenis_permohonan }}</td>
                <!-- Nomor Penerbitan -->
                <td>{{ data.nomor_izin_terbit }}</td>
                <!-- Tgl. Penerbitan -->
                <td>{{ formatDate(data.tgl_penerbitan, 'DD MMMM YYYY') }}</td>
                <!-- Masa Berlaku -->
                <td>{{ formatDate(data.masa_berlaku, 'DD MMMM YYYY') }}</td>
                <!-- PIC -->
                <td>{{ data.pic_name || '-' }}</td>
                <!-- Tgl. Dibuat -->
                <td>{{ formatDate(data.createdAt, 'DD MMMM YYYY') }}</td>
                <!-- Status -->
                <td>{{ data.status }}</td>
                <!-- File -->
                <td>
                  <div style="width: 250px" class="row">
                    <div class="col-8">
                      <select style="width: 150px; margin-right: 10px" class="form-select" v-model="data.selected_file">
                        <option disabled selected value="#">- Pilih File -</option>
                        <option v-for="file in listUnduhFile(data)" :value="file.value" :disabled="!file.value">
                          {{ file.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-4 d-flex align-items-center">
                      <span v-if="data.selected_file !== '#'">
                        <a :href="data.selected_file" target="_blank">
                          <i class="fa fa-download" style="font-size: 20px" />
                        </a>
                      </span>
                    </div>
                  </div>
                </td>
                <!-- Aksi -->
                <!-- <td>
                  <div style="max-width: 200px">
                    <b-button-toolbar>
                      <b-button
                        v-if="isJadwalPentek(data)"
                        size="sm"
                        variant="warning"
                        class="text-white m-1 btn-inverse"
                        @click="showModalJadwalPentek(true, data)"
                      >
                        <i class="fa fa-file-text-o"></i> Jadwal Pentek
                      </b-button>
                      <b-button
                        v-if="isPemutakhiran(data)"
                        size="sm"
                        variant="warning"
                        class="text-white m-1"
                        @click="$router.push(`/app/habis-masa-berlaku/pemutakhiran?id_pemutakhiran=${data.id}`)"
                      >
                        <i class="fa fa-file-o"></i> Pemutakhiran
                      </b-button>
                      <b-button
                        v-if="isFinalisasiBa(data)"
                        size="sm"
                        variant="primary"
                        class="text-white m-1"
                        @click="showModalFinalisasiBa(true, data)"
                      >
                        <i class="fa fa-tasks"></i> Finalisasi BA
                      </b-button>
                      <b-button
                        v-if="isUnggahPerubahan(data)"
                        size="sm"
                        variant="success"
                        class="text-white m-1"
                        @click="showModalPerubahan(true, data)"
                      >
                        <i class="fa fa-cloud-upload"></i> Unggah Putusan
                      </b-button>
                      <b-button
                        v-if="isKirimDokumenCoofis(data)"
                        size="sm"
                        variant="primary"
                        class="text-white m-1"
                        @click="sendDataCoofis(data)"
                      >
                        <i class="fa fa-cloud-upload"></i> Kirim Dokumen ke Coofis
                      </b-button>
                      <b-button v-if="isFinalisasi(data)" size="sm" variant="secondary" class="text-white m-1">
                        <i class="fa fa-check"></i> Finalisasi
                      </b-button>
                      <b-button
                        v-if="isHapus()"
                        size="sm"
                        variant="danger"
                        class="text-white m-1"
                        @click="deleteData(data.id)"
                      >
                        <i class="fa fa-trash-o"></i> Hapus
                      </b-button>
                    </b-button-toolbar>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
          <!-- prettier-ignore -->
          <div class="d-flex justify-content-between mt-4">
          <div>
            <template v-if="pagination.total">
              Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ? pagination.limit*pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
            </template>
          </div>
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'first'})">
                  <span aria-hidden="true">Awal</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'prev'})">
                  <span aria-hidden="true">Sebelumnya</span>
                </a>
              </li>
              <li 
                v-for="i in pagination.pageNumber" 
                class="page-item"
              >
                <a :class="['page-link', {'active': i === `${pagination.currentPage}`}]" href="#" @click="changePage({page: i})">{{ i }}</a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'next'})">
                  <span aria-hidden="true">Selanjutnya</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'last'})">
                  <span aria-hidden="true">Akhir</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        </div>
      </Widget>

      <b-modal id="modal-jadwal-pentek" title="Jadwal Penilaian Teknis" size="md">
        <template>
          <b-form>
            <div class="row g-0">
              <div class="col-12">
                <label for="pic_id">PIC <span class="text-danger">*</span></label>
                <v-select
                  id="pic_id"
                  v-model="formJadwalPentek.pic_id"
                  :reduce="(data) => data.id"
                  label="nama"
                  :options="dataPic"
                  name="PIC"
                  v-validate="'required'"
                  placeholder="Pilih PIC"
                />
                <span class="text-danger" v-if="errors.has('PIC')">
                  {{ errors.first('PIC') }}
                </span>
              </div>
              <div class="col-12 mt-3">
                <label for="jadwal_verifikasi_teknis">
                  Jadwal Penilaian Teknis <span class="text-danger">*</span>
                </label>
                <b-form-input
                  type="date"
                  id="jadwal_verifikasi_teknis"
                  v-model="formJadwalPentek.jadwal_verifikasi_teknis"
                  v-validate="'required'"
                  name="Jadwal Penilaian Teknis"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Jadwal Penilaian Teknis')">
                  {{ errors.first('Jadwal Penilaian Teknis') }}
                </span>
              </div>
              <div class="col-12 mt-3">
                <label for="waktu_verifikasi_teknis"> Waktu Penilaian Teknis <span class="text-danger">*</span> </label>
                <b-form-input
                  type="time"
                  id="waktu_verifikasi_teknis"
                  v-model="formJadwalPentek.waktu_verifikasi_teknis"
                  v-validate="'required'"
                  name="Waktu Penilaian Teknis"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Waktu Penilaian Teknis')">
                  {{ errors.first('Waktu Penilaian Teknis') }}
                </span>
              </div>
              <div class="col-12 mt-3">
                <label for="filename_final_undangan"> File Undangan </label>
                <InputFile
                  v-model="formJadwalPentek.filename_final_undangan"
                  id="filename_final_undangan"
                  name="File Undangan"
                  accept=".pdf"
                />
              </div>
              <div class="col-12 mt-3">
                <label for="filename_final_surat_tugas"> File Surat Tugas </label>
                <InputFile
                  v-model="formJadwalPentek.filename_final_surat_tugas"
                  id="filename_final_surat_tugas"
                  name="File Surat Tugas"
                  accept=".pdf"
                />
              </div>
            </div>
          </b-form>
        </template>
        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              size="sm"
              class="float-right"
              @click="submitFormJadwalPentek"
              :disabled="isLoading"
            >
              <img src="../../../assets/icons/archive.svg" />
              Simpan
            </b-button>
          </div>
        </template>
      </b-modal>

      <b-modal id="modal-finalisasi-ba" title="Finalisasi BA" size="md">
        <template>
          <b-form>
            <div class="row g-0">
              <div class="col-12">
                <label for="nomor_ba_vertek"> Nomor Berita Acara <span class="text-danger">*</span> </label>
                <b-form-input
                  id="nomor_ba_vertek"
                  v-model="formFinalisasiBa.nomor_ba_vertek"
                  v-validate="'required'"
                  name="Nomor Berita Acara"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Nomor Berita Acara')">
                  {{ errors.first('Nomor Berita Acara') }}
                </span>
              </div>
            </div>
          </b-form>
        </template>
        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              size="sm"
              class="float-right"
              @click="submitFormFinalisasiBa"
              :disabled="isLoading"
            >
              <img src="../../../assets/icons/archive.svg" />
              Simpan
            </b-button>
          </div>
        </template>
      </b-modal>

      <b-modal id="modal-perubahan" title="Upload Konsep Putusan" size="md">
        <template>
          <b-form>
            <div class="row g-0">
              <div class="col-12">
                <label for="konseptor"> Konseptor <span class="text-danger">*</span> </label>
                <v-select
                  id="konseptor"
                  v-model="formPerubahan.nip_composer"
                  :reduce="(data) => data.nip"
                  label="nama"
                  :options="dataNIP"
                  name="Konseptor"
                  v-validate="'required'"
                  placeholder="Pilih Konseptor"
                />
                <span class="text-danger" v-if="errors.has('Konseptor')">
                  {{ errors.first('Konseptor') }}
                </span>
              </div>
              <div class="col-12 mt-3">
                <label for="file_konsep_putusan">
                  File Konsep Putusan
                  <span class="text-danger">*</span>
                </label>
                <InputFile
                  v-model="formPerubahan.file_konsep_putusan"
                  id="file_konsep_putusan"
                  name="File Konsep Putusan"
                  accept=".pdf"
                  v-validate="'required'"
                />
                <span class="text-danger" v-if="errors.has('File Konsep Putusan')">
                  {{ errors.first('File Konsep Putusan') }}
                </span>
              </div>
            </div>
          </b-form>
        </template>
        <template #modal-footer>
          <div class="w-100">
            <b-button variant="primary" size="sm" class="float-right" @click="uploadSurket" :disabled="isLoading">
              <img src="../../../assets/icons/archive.svg" />
              Simpan
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Widget from '@/components/Widget/Widget'
import vSelect from 'vue-select'
import { formatDate } from '../../../helper/helpernew'
import { Validator } from 'vee-validate'
import InputFile from '../Components/InputFile.vue'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  components: { Widget, vSelect, InputFile },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      dataPermohonan: [],
      dataPic: [],
      formJadwalPentek: {
        pic_id: null,
        jadwal_verifikasi_teknis: null,
        waktu_verifikasi_teknis: null,
        filename_final_undangan: null,
        filename_final_surat_tugas: null,
      },
      formFinalisasiBa: {
        nomor_ba_vertek: null,
      },
      dataNIP: [],
      formPerubahan: {
        nip_composer: null,
        file_konsep_putusan: null,
      },

      selectedData: null,
      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: 'nama_pemohon',
        value: '',
      },
      sort: {
        field: 'createdAt',
        direction: 'DESC',
      },
      debounceTerm: null,
      isLoading: false,
      showLoading: false,
    }
  },
  methods: {
    async getdata() {
      $('#tableHabisMasaBerlaku').DataTable().destroy()
      return this.loaddata()
    },

    async loaddata() {
      this.showLoading = true
      this.dataPermohonan = []

      // prettier-ignore
      const api = `api/ref/getPermohonan/Habis`+
        `?page=${this.pagination.currentPage}`+
        `${this.search.value!==''?`&filter=${this.search.field},${this.search.field==='tanggal_penerbitan'||this.search.field==='masa_berlaku'?'>=':'like'},${this.search.value}`:''}`+
        `&sort=${this.sort.field},${this.sort.direction}`

      return axios.get(this.baseapiPengendalian + api, this.getApiOption()).then((response) => {
        const data = response.data
        this.pagination.limit = data.limit
        this.pagination.total = data.total
        this.pagination.firstInPage = (this.pagination.currentPage - 1) * data.limit + 1
        this.pagination.lastPage = Math.ceil(data.total / data.limit)
        this.setPagination()
        this.dataPermohonan = response.data.data.map((d) => ({
          ...d,
          selected_file: '#',
        }))
        this.initDatatable()
        this.showLoading = false
      })
    },

    async submitFormJadwalPentek() {
      const validation = await this.$validator.validateAll()
      if (!validation) return

      const confirm = await Swal.fire({
        title: 'Simpan Jadwal Pentek?',
        text: 'Tindakan ini tidak bisa dibatalkan',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, Simpan',
        cancelButtonText: 'Batal',
      })
      if (!confirm.isConfirmed) return

      const id = this.selectedData.id
      const formData = new FormData()
      for (const d in this.formJadwalPentek) {
        if (this.formJadwalPentek[d]) formData.append(d, this.formJadwalPentek[d])
      }

      try {
        this.$loading(true)
        this.isLoading = true

        await axios.post(`${this.baseapiPengendalian}api/habis_masa_berlaku/setJadwalPentek/${id}`, formData, this.getApiOption())

        await axios.post(`${this.baseapiPengendalian}api/habis_masa_berlaku/${id}`, { status: 'Penilaian' }, this.getApiOption())

        Swal.fire({
          title: 'Berhasil',
          text: 'Berhasil set Jadwal Penilaian Teknis',
          icon: 'success',
        })
        this.showModalJadwalPentek(false, null)
        this.getdata()
      } catch (error) {
        Swal.fire({
          title: 'Gagal',
          text: 'Gagal set Jadwal Penilaian Teknis',
          icon: 'error',
        })
      } finally {
        this.$loading(false)
        this.isLoading = false
      }
    },

    async submitFormFinalisasiBa() {
      const validation = await this.$validator.validateAll()
      if (!validation) return

      const id = this.selectedData.id

      const formData = {}
      for (const d in this.formFinalisasiBa) {
        if (this.formFinalisasiBa[d]) formData[d] = this.formFinalisasiBa[d]
      }

      try {
        this.$loading(true)
        this.isLoading = true

        await axios.put(`${this.baseapiPengendalian}api/habis_masa_berlaku/setNomorPentek/${id}`, formData, this.getApiOption())
        Swal.fire({
          title: 'Berhasil',
          text: 'Berhasil finalisasi Berita Acara',
          icon: 'success',
        })
        this.showModalFinalisasiBa(false, null)
        this.getdata()
      } catch (error) {
        Swal.fire({
          title: 'Gagal',
          text: 'Gagal finalisasi Berita Acara',
          icon: 'error',
        })
      } finally {
        this.$loading(false)
        this.isLoading = false
      }
    },

    async uploadSurket() {
      const validation = await this.$validator.validateAll()
      if (!validation) return

      this.$loading(true)
      this.isLoading = true
      const id = this.selectedData.id
      const formData = new FormData()
      for (const k in this.formPerubahan) {
        formData.append(k, this.formPerubahan[k])
      }

      try {
        await axios.post(`${this.baseapiPengendalian}api/habis_masa_berlaku/submitPutusan/${id}`, formData, this.getApiOption())

        await axios.post(
          `${this.baseapiPengendalian}api/habis_masa_berlaku/${id}`,
          { status: 'Penyusunan Konsep Putusan' },
          this.getApiOption(),
        )

        Swal.fire({
          title: 'Berhasil',
          text: 'Berhasil upload Konsep Putusan',
          icon: 'success',
        })
        this.showModalPerubahan(false, null)
        this.getdata()
      } catch (error) {
        Swal.fire({
          title: 'Gagal',
          text: 'Gagal upload Konsep Putusan',
          icon: 'error',
        })
      }
      this.$loading(false)
      this.isLoading = false
    },

    async sendDataCoofis(record) {
      const confirm = await Swal.fire({
        title: 'Kirim Dokumen ke Coofis',
        text: 'Apakah Anda yakin ingin mengirim dokumen ke Coofis?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, kirim',
      })
      if (!confirm.isConfirmed) return

      const { id } = record
      try {
        this.$loading(true)
        await axios.put(`${this.baseapiPengendalian}api/habis_masa_berlaku/sendDataCoofis/${id}`, {}, this.getApiOption())

        await axios.post(
          `${this.baseapiPengendalian}api/habis_masa_berlaku/${id}`,
          { status: 'Menunggu Persetujuan Pejabat' },
          this.getApiOption(),
        )

        this.getdata()
        Swal.fire({
          title: 'Berhasil',
          text: 'Dokumen berhasil dikirim ke Portal Coofis',
          icon: 'success',
        })
      } catch (error) {
        Swal.fire({
          title: 'Gagal',
          text: 'Dokumen gagal dikirim ke Portal Coofis',
          icon: 'error',
        })
      } finally {
        this.$loading(false)
      }
    },

    deleteData(id) {
      Swal.fire({
        title: 'Apakah Anda yakin?',
        text: 'Anda tidak akan dapat mengembalikan data ini!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Batal',
      }).then(async (val) => {
        if (val.isConfirmed) {
          axios
            .delete(this.baseapiPengendalian + 'api/habis_masa_berlaku/' + id, this.getApiOption())
            .then((response) => {
              Swal.fire('Berhasil', 'Berhasil menghapus record', 'success')
              this.getdata()
            })
            .catch((error) => {
              Swal.fire('Gagal', 'Gagal menghapus record', 'error')
            })
        }
      })
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch((err) => {})

      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment('DD MMMM YYYY')
        var t = $('#tableHabisMasaBerlaku').DataTable({
          paging: false,
          info: false,
          filter: false,
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                return type == 'export' ? meta.row + 1 : data
              },
            },
          ],
          buttons: [],
        })
      }, 300)
    },

    showModalJadwalPentek(val, record) {
      this.selectedData = record
      if (val) {
        this.$bvModal.show('modal-jadwal-pentek')
      } else {
        this.$bvModal.hide('modal-jadwal-pentek')
        this.formJadwalPentek = {
          pic_id: null,
          jadwal_verifikasi_teknis: null,
          waktu_verifikasi_teknis: null,
          filename_final_undangan: null,
          filename_final_surat_tugas: null,
        }
      }
    },

    showModalFinalisasiBa(val, record) {
      this.selectedData = record
      if (val) {
        if (!record.ttd_ba_vertek_1_status || !record.ttd_ba_vertek_2_status || !record.ttd_ba_vertek_4_status) {
          Swal.fire(
            'Tanda Tangan Belum Lengkap',
            'Mohon lengkapi tanda tangan untuk melanjutkan Finalisasi Berita Acara',
            'warning',
          )
          return
        }

        this.$bvModal.show('modal-finalisasi-ba')
      } else {
        this.$bvModal.hide('modal-finalisasi-ba')
      }
    },

    showModalPerubahan(val, record) {
      this.selectedData = record
      if (val) {
        this.$bvModal.show('modal-perubahan')
      } else {
        this.$bvModal.hide('modal-perubahan')
      }
    },

    loadNIP() {
      axios
        .get(this.baseapiPengendalian + 'api/sync/getComposerMirror', {
          headers: {
            Authorization: this.tokenCoofis,
          },
        })
        .then((response) => {
          this.dataNIP = response.data.result
        })
    },

    loadPIC() {
      axios.get(this.baseapiPengendalian + 'api/user?filter=role,=,pic_pemutakhiran', this.getApiOption()).then((res) => {
        this.dataPic = res.data.data
      })
    },

    showModalSurket(record) {
      this.$bvModal.show('modal-surket')
      this.selectedData = record
    },

    isJadwalPentek(record) {
      return !record.pic_id || !record.jadwal_verifikasi_teknis || !record.waktu_verifikasi_teknis
    },

    isPemutakhiran(record) {
      return (
        this.user.role === 'pic_pemutakhiran' &&
        record.pic_id &&
        record.jadwal_verifikasi_teknis &&
        record.waktu_verifikasi_teknis &&
        !record.ttd_ba_vertek_1_status &&
        !record.ttd_ba_vertek_2_status &&
        !record.ttd_ba_vertek_4_status
      )
    },

    isFinalisasiBa(record) {
      return (
        this.user.role === 'pic_pemutakhiran' &&
        record.hasil_verifikasi_teknis &&
        record.ttd_ba_vertek_1 &&
        record.ttd_ba_vertek_2 &&
        record.ttd_ba_vertek_4 &&
        record.pimpinan_rapat &&
        record.file_berita_acara &&
        !record.nomor_ba_vertek
      )
    },

    isUnggahPerubahan(record) {
      return (
        this.user.role === 'pic_pemutakhiran' &&
        ((record.nomor_ba_vertek && !record.file_konsep_putusan) || record.status === 'Penyusunan Konsep Putusan')
      )
    },

    isKirimDokumenCoofis(record) {
      return (
        this.user.role === 'pic_pemutakhiran' &&
        record.nip_composer &&
        record.file_konsep_putusan &&
        record.status === 'Penyusunan Konsep Putusan'
      )
    },

    isFinalisasi(record) {
      return this.user.role === 'pic_pemutakhiran' && record.file_final_putusan && record.status !== 'Selesai'
    },

    isHapus() {
      return ['superuser', 'tim_teknis_pemutakhiran'].includes(this.user.role)
    },

    listUnduhFile(record) {
      return [
        {
          label: 'Surat Rekomendasi',
          value: record.file_rekomendasi_habis_masa_berlaku,
        },
        {
          label: 'Surat Undangan',
          value: record.filename_final_undangan,
        },
        {
          label: 'Surat Tugas',
          value: record.filename_final_surat_tugas,
        },
        {
          label: 'Berita Acara',
          value: record.file_berita_acara,
        },
        {
          label: 'Konsep Putusan',
          value: record.file_konsep_putusan,
        },
        {
          label: 'Final Putusan',
          value: record.file_final_putusan,
        },
      ]
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },

    formatDate,
  },
  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getdata()
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getdata()
      },
      deep: true,
    },
  },
  mounted() {
    this.getdata()
    // this.loadNIP()
    // this.loadPIC()

    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
}
</script>
